enum CampaignType {
  invited = 'opportunity-invitation',
  opportunity = 'opportunity',
  brandLovers = 'brandlovers',
  performance = 'performance',
  researches = 'survey',
  participating = 'participating',
  sent = 'applications-sent',
  finished = 'finished',
}

export default CampaignType
